import React from 'react';

import { ActionBase } from './ActionBase';
import { reducer } from './Reducer';
import { initialState, Store } from './Store';

////////////////////////////////////////////////////////////////////////////////
// Context
////////////////////////////////////////////////////////////////////////////////
type StoreContextValue = [Store, React.Dispatch<ActionBase> | null];
const StoreContext = React.createContext<StoreContextValue>([{} as Store, null]);

////////////////////////////////////////////////////////////////////////////////
// Component
////////////////////////////////////////////////////////////////////////////////
export const StoreComponent = React.memo(({ children }) => {
	const [state, dispatch] = React.useReducer(reducer, initialState);

	// console.log(`StoreComponent[${JSON.stringify(state)}]`);

	return <StoreContext.Provider value={[state, dispatch]}>{children}</StoreContext.Provider>;
});

export const useStore = () => React.useContext(StoreContext);
